"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntegrationType = void 0;
var IntegrationType;
(function (IntegrationType) {
    IntegrationType["Discord"] = "discord";
    IntegrationType["Slack"] = "slack";
})(IntegrationType = exports.IntegrationType || (exports.IntegrationType = {}));
